import { get, post } from '../../http'
import { LIVE_GW_URL } from '../../baseUrl'

export const flexiblePayAccountInfoByEncrypt = params =>
  get(
    `${LIVE_GW_URL}/shop/promoter/client/bankAccount/flexiblePayAccountInfoByEncrypt`,
    params
  )
